import React from "react";
import { Link } from "react-router-dom";

export default function Projects() {
  const projects = [
    {
      title: "Care Platform",
      url: "https://careplatform.peoplevcare.com/",
      image: `${process.env.PUBLIC_URL}/logo.webp`,
      imageClassName: "object-contain bg-white p-5"
    },
    { 
      title: "Maplee Marketplace",
      slug: "maplee-market-place",
      image: `${process.env.PUBLIC_URL}/Maplee-Open-Graph.avif`
    },
    { 
      title: "(Previous) Maplee", 
      slug: "previous-maplee",
      image: `${process.env.PUBLIC_URL}/Maplee4.png` 
    },
    { 
      title: "Facial Recognition", 
      slug: "facial-recognition",
      image: `${process.env.PUBLIC_URL}/Facial-Recognition.png` 
    },
    { 
      title: "Facebook Post ML Analysis", 
      slug: "facebook-post-ml-analysis",
      image: `${process.env.PUBLIC_URL}/Facebook-Market.png` 
    },
    { 
      title: "Boggle Algorithms", 
      slug: "boggle-algorithms",
      image: `${process.env.PUBLIC_URL}/Boggle.png` 
    },
    { 
      title: "Data Analysis of Student Responses", 
      slug: "data-analysis-of-student-responses",
      image: `${process.env.PUBLIC_URL}/Stuent-Response.png` 
    },
    { 
      title: "Image Generation", 
      slug: "image-generation",
      image: `${process.env.PUBLIC_URL}/Car.png` 
    },
    { 
      title: "Paper Trading", 
      slug: "paper-trading",
      image: `${process.env.PUBLIC_URL}/Paper-Trading.png` 
    },
    { 
      title: "Gym Database", 
      slug: "gym-database",
      image: `${process.env.PUBLIC_URL}/Gym-Database.png` 
    },
    { 
      title: "Club Finance App", 
      slug: "club-finance-app",
      image: `${process.env.PUBLIC_URL}/Finance-App.png` 
    },
  ];

  return (
    <div 
      className="flex flex-col min-h-screen bg-gray-900 text-white px-8 pt-20"
      style={{
        backgroundImage: `url(${process.env.PUBLIC_URL}/BG3.png)`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      <h1 className="text-4xl font-bold mb-12 text-center text-purple-400 pt-8">
        Here are a few of my projects
      </h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 flex-grow mb-20">
        {projects.map((project, index) => {
          const cardClassName =
            "group bg-black/60 backdrop-blur-md p-4 rounded-lg shadow-lg hover:-translate-y-1 hover:bg-black/70 transition cursor-pointer";
          const cardContent = (
            <>
            <img 
              src={project.image} 
              alt={project.title} 
              className={`w-full h-40 rounded-md mb-4 transition duration-300 group-hover:opacity-90 ${
                project.imageClassName || "object-cover"
              }`} 
            />
            <h2 className="text-xl font-semibold text-center">
              {project.title}
            </h2>
            </>
          );

          return project.url ? (
            <a
              key={index}
              href={project.url}
              target="_blank"
              rel="noreferrer"
              className={cardClassName}
            >
              {cardContent}
            </a>
          ) : (
            <Link
              key={index}
              to={`/projects/${project.slug}`}
              className={cardClassName}
            >
              {cardContent}
            </Link>
          );
        })}
      </div>
    </div>
  );
}
